import styled, { css } from 'styled-components'
import Arrow from './../../common/images/arrow.svg'
import { Form } from 'react-bootstrap'
import { theme } from './../../common'
import { Document } from 'react-pdf/dist/esm/entry.webpack';

export const StyledDivider = styled.div`
    background-color: #FFFFFF;
`
export const StyledDividerLine = styled.span`
    height: 1px;
    width: 93%;
    margin: 0 auto;
    background-color: #707070;
    display: block;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
    left: 0;
    right: 0;
`
export const StyledTitle = styled.h1`
    font-size: 2.7em;
    font-weight: bold;
    z-index: 0;
    padding: 0 20px;
    text-transform: uppercase;
`

export const StyledCarouselItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
        max-width: 240px;
        height: auto;
    }
`

export const StyledCarouselWrapper = styled.div`
.alice-carousel__next-btn, .alice-carousel__prev-btn {
    span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        &:after {
            content: '';
            display: block;
            width: 30px;
            height: 30px;
            background-image: url(${Arrow});
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    @media screen and (max-width: 576px) {
        display: none;
    }
}
    .alice-carousel__next-btn {
        span {
            right: -5%;
            @media screen and (max-width: 992px) {
                right: 0px;
            }   
        }
    }

    .alice-carousel__prev-btn {
        span {
            left: -5%;
            transform: translateY(-50%) rotate(180deg);
            @media screen and (max-width: 992px) {
                left: 0px;
            }
        }
    }

    .alice-carousel__wrapper {
        padding: 5% 0px;
    }
    .alice-carousel__stage-item {
        padding: 0px 10px;
        transition: .7s;
        &.centered {
            z-index: 10;
            -webkit-box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.15);
            -moz-box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.15);
            box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.15);
            @media screen and (max-width: 992px) {
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }
        }
        ${StyledCarouselItem} {
            height: 350px;
            position: relative;
        }           
    }
`
export const StyledTrHead = styled.tr`
    text-align: center;
    text-transform: uppercase;
    font-size: 1.3em;
`
export const StyledThHead = styled.th`

`

export const StyledTr = styled.tr`
    &:nth-of-type(odd) {
        background-color: #F0F0F0;
    }
`
export const StyledTd = styled.td`
    text-align: center;
`




export const StyledLogo = styled.img`
    display: ${({show}) => show ? 'block' : 'none'};
    max-width: 250px;
    height: auto;
`

export const StyledSelect = styled(Form.Control)`
    background-color: ${theme.primary};
    color: ${theme.white};
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    border: none;
    padding: 5px;
`

export const StyledLogoo = styled.img`
    width: 100%;
    height: auto;
    border-top: 2px solid ${theme.primary};
    border-bottom: 2px solid ${theme.primary};
    padding: 10px;
`

export const StyledDocument = styled(Document)`
`

export const StyledActionsContainer = styled.div`
    margin-top: 5%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    p {
        margin: 0;
    }
`

export const StyledNavigationIcon = styled.img`
    cursor: pointer;
    &.left {
        transform: rotate(180deg);
    }
`

export const StyledOutlinedButton = styled.a`
    color: ${theme.primary};
    border: 1px solid ${theme.primary};
    font-size: 1.5em;
    padding: 5px 15px;
    border-radius: 5px;
    transition: .3s;
    &:hover {
        background-color: ${theme.primary};
        color: ${theme.white};
        text-decoration: none;
    }
`